module.exports = __webpack_public_path__ + "static/media/RAYAN HAYIK.4572e83f.png";